const allModuleAccess = (state = {}, action) => {
    if (action.type === "moduleAccess") {
      return (state = action.payload);
    } else {
      return state;
    }
  };
  export default allModuleAccess;
  